import { createBrowserRouter, Navigate } from "react-router-dom";
import { BriefPage } from "@/pages/BriefPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { EvidencePage } from "@/pages/EvidencePage";
import { PlanPage } from "@/pages/PlanPage";
import { ReportPage } from "@/pages/ReportPage";
import { AppShell } from "@/widgets/AppShell";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: "dashboard", element: <DashboardPage /> },
      { path: "brief", element: <BriefPage /> },
      { path: "brief/:slug", element: <BriefPage /> },
      { path: "plan", element: <PlanPage /> },
      { path: "evidence", element: <EvidencePage /> },
      { path: "report", element: <ReportPage /> },
    ],
  },
]);